import { TUserState } from '../../types/user';

const defaultState: TUserState = {
  isAuthenticated: false,
};

export function userReducer(state: TUserState = defaultState): TUserState {
  return state;
}
